module.exports = __webpack_public_path__ + "static/result-b41e8f21188403ac47a6f475bd47c988.png";